import { publicApiUrl } from "@frontend/lib/api";

function avatarVersion(avatarKey: string): string {
  return avatarKey
    .replace(/\.[a-z0-9]+$/i, "")
    .replace(/[^a-z0-9]/gi, "")
    .slice(-12);
}

export function collabCounterpartAvatarUrl(collab: {
  counterpartCreatorId: string | null;
  counterpartAvatarKey: string | null;
}): string | null {
  if (!collab.counterpartCreatorId) return null;
  return creatorAvatarUrl(collab.counterpartCreatorId, collab.counterpartAvatarKey);
}

export function creatorAvatarUrl(creatorId: string, avatarKey: string | null): string | null {
  if (!avatarKey) return null;
  return `${publicApiUrl()}/api/creators/${creatorId}/avatar?v=${avatarVersion(avatarKey)}`;
}

/** Photo for someone on the other side of a collab who booked under this phone. */
export function accountAvatarUrl(
  account: { id: string; avatarKey: string | null } | null | undefined,
): string | null {
  if (!account) return null;
  return creatorAvatarUrl(account.id, account.avatarKey);
}
